export default "/images/vendor/flag-icon-css/flags/4x3/it.svg?08db2cd122d5f99494dd35c2cfb10784";